import React, { useState, useEffect } from 'react';

import NavigationDrawer from '../../../../components/navigationDrawer';
import { useLocation } from 'react-router-dom';
import { Grid, Typography, styled, Container, Button } from '@mui/material';
import orderStyle from './style';
import { useNavigate } from 'react-router-dom';
import { updateRestOrderStatus } from '../../../../services/orders';
import Loader from '../../../../components/loader';
import SnackbarAlert from '../../../../components/snackbar/SnackbarAlert';

const TripDetail = () => {
  const navigate = useNavigate();
  const classes = orderStyle();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem('user'));
  const [tripData, setTripData] = useState(null);
  const [subTotal, setSubTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [statusVal, setStatusVal] = useState('');
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: '',
    message: '',
  });

  console.log(location.state, 'statestatestatestatestate');

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  useEffect(() => {
    setTripData(location.state);
  }, []);

  const StyledTypo = styled(Typography)`
    font-size: 15px;
    font-weight: 600;
    padding-top: 5px;
  `;

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, '', '');
  };

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <div
        style={{
          boxShadow: '0 0.2rem 1rem rgb(0 0 0 / 12%)',
          padding: '20px',
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography style={{ fontSize: '22px', fontWeight: '600' }}>
              Matches Details
            </Typography>
            <div>
              <StyledTypo>
                Name:{' '}
                <span style={{ fontWeight: '500' }}>{tripData?.tripName}</span>
              </StyledTypo>
              <StyledTypo>
                Date:{' '}
                <span style={{ fontWeight: '500' }}>{tripData?.date}</span>
              </StyledTypo>
              <StyledTypo>
                Persons:{' '}
                <span style={{ fontWeight: '500' }}>{tripData?.persons}</span>
              </StyledTypo>
            </div>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <div style={{ textAlign: 'right' }}>
              <img
                src={tripData?.image}
                style={{
                  width: 150,
                  height: 150,
                }}
              />
            </div>
          </Grid> */}
        </Grid>
        <Typography
          style={{ fontSize: '22px', fontWeight: '600', marginTop: '10px' }}
        >
          Users's Details
        </Typography>
        <Grid container spacing={3}>
          {tripData?.users.map((item) => {
            return (
              <Grid item xs={12} sm={6} md={4} lg={3} marginTop={2}>
                <div
                  style={{
                    borderRadius: '20px',
                    boxShadow: '0 0.2rem 1rem rgb(0 0 0 / 12%)',
                    padding: '10px',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <img
                      src={item?.profilePicture}
                      style={{
                        width: 120,
                        height: 120,
                        borderRadius: '50%',
                      }}
                    />
                  </div>
                  <StyledTypo>
                    Name:{' '}
                    <span style={{ fontWeight: '500' }}>{item?.name}</span>
                  </StyledTypo>
                  <StyledTypo>
                    Gender:{' '}
                    <span style={{ fontWeight: '500' }}>{item?.gender}</span>
                  </StyledTypo>
                  <StyledTypo>
                    Email:{' '}
                    <span style={{ fontWeight: '500' }}>{item?.email}</span>
                  </StyledTypo>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </NavigationDrawer>
  );
};

export default TripDetail;
